module.exports    = {
	"language": "语言",
	"hello": "世界 {{.a}}",
	"c001": "Network error, please try again later! ",
	"c002": "Exit",
	"c003": "Login",
	"c004": "Please enter username",
	"c005": "Please enter login password",
	"c006": "Save",
	"c007": "The account or password you filled in is incorrect",
	"c008": "Account",
	"c009": "Language",
	"c010": "total",
	"c011": "items",
	"c012": "Hello, ",
	"c013": "Your account is not activated, please contact the administrator",
	"c014": "Your account has been frozen, please contact the administrator",
	"c015": "Reset",
	"c016": "WebSocket connection failed",
	"c017": "Internal Error",
	"c018": "You do not have permission to perform this action.",
	"c019": "The current user does not have permission to view this page.",
	"c020": "Login information has expired.Please log in again! ",
	"c021": "User Login",
	"c022": "Document",
	"cC023": "Qualified",
	"cC024": "bad",
	"c025": "Result",
	"c026": "System",
	"c027": "Database connection exception, please check. ",
	"c028": "exception d'initialisation de base de données, veuillez vérifier",
	"m001": "Offline",
	"m002": "Online",
	"m003": "Exception",
	"m004": "Deleted",
	"m005": "Add Device",
	"m006": "Edit Device",
	"m007": "Device Management",
	"m008": "Number",
	"m009": "Status",
	"m010": "Device Number",
	"m011": "Device Name",
	"m012": "Production line",
	"m013": "Sort",
	"m014": "IP Address",
	"m015": "Mailing Address",
	"m016": "Remarks",
	"m017": "Update Time",
	"m018": "Operation",
	"m019": "Edit",
	"m020": "Device editing successful",
	"m021": "Device added successfully",
	"m022": "Duplicate device names, device numbers, or IP addresses",
	"m023": "The device name cannot be empty and its length cannot be less than 2",
	"m024": "The device number cannot be empty and the length cannot be less than 2",
	"m025": "IP address cannot be empty",
	"m026": "The port must be an integer and cannot exceed 5 digits",
	"m027": "Delete",
	"m028": "Recovery",
	"m029": "Port",
	"m030": "Start automatic online connection",
	"m031": "Reminder: The communication address needs to be consistent with the one in the welding machine programmer",
	"m032": "All production lines",
	"m033": "All States",
	"m034": "Please select",
	"m035": "Online",
	"m036": "Offline",
	"m037": "Device deletion exception, please try again later",
	"m038": "Device recovery exception, please try again later",
	"m039": "Device deleted successfully",
	"m040": "Device recovery successful",
	"m041": "Abnormal device data retrieval, please try again later",
	"m042": "IP format incorrect",
	"m043": "The communication address must be an integer and cannot exceed 5 digits",
	"m044": "Please select the production line to which it belongs",
	"m045": "Editing device failed",
	"m046": "Device addition failed",
	"m047": "Duplicate device name, please modify",
	"m048": "Duplicate device number, please modify",
	"m049": "IP address duplicate, please modify",
	"m050": "Collect current curve",
	"m051": "Collect voltage curve",
	"m052": "Collect resistance curve",
	"m053": "Collect pressure curve",
	"m054": "Automatic Online",
	"m055": "Explain import file error",
	"m056": "Error reading uploaded file",
	"m057": "File extension error (.xlsx;.xlsm;.xltx)",
	"m058": "File too large (10M)",
	"m059": "Device",
	"m060": "Field",
	"m061": "Import completed, a total of {{.a}} entries were imported, including {{.b}} new entries",
	"m062": "Import failed",
	"m063": "Close",
	"m064": "Same specification, no comparison allowed",
	"m065": "Error in querying the controller list",
	"m066": "File extensions are not allowed",
	"m067": "Incorrect password.Please re-enter.",
	"m068": "Upgrade successful",
	"m069": "Are you sure you want to restore the controller to factory settings?",
	"m070": "Device type only supports 803",
	"m071": "The system is processing, please wait a moment.",
	"m072": "Task added successfully, processing...",
	"m073": "Import will overwrite existing data.Are you sure you want to proceed?",
	"m074": "File write exception",
	"m075": "Query device name/device number/IP address/remark",
	"m076": "All online",
	"m077": "All offline",
	"m078": "All online successfully",
	"m079": "All offline successfully",
	"m080": "All online failures",
	"m081": "All offline failed",
	"m082": "can nto create excel tables",
	"m083": "Error in welding curve deserialization",
	"m084": "Failed to retrieve alarm records",
	"m085": "Error writing system parameter 1",
	"m086": "Exception in writing system parameter 2",
	"m087": "Abnormal writing to system parameter 3",
	"m088": "Could not find.Please first add the corresponding production line.",
	"m089": "Total machine",
	"m090": "Reconnect",
	"m091": "Backup",
	"m092": "Specification parameter",
	"m093": "Backup system parameters",
	"m094": "You haven't selected any device!",
	"m095": "You have not selected any parameters for backup!",
	"m096": "Batch backup is in progress, please wait",
	"m097": "The backup does not exist!",
	"m098": "Backup packaging exception!",
	"m099": "Batch backup completed, please download",
	"m100": "Failed to create tar file",
	"m101": "Failed to obtain path",
	"m102": "Backup successful",
	"m103": "Please select the file to upgrade",
	"m104": "Device Upgrade",
	"m105": "Exception occurred during upgrade process",
	"m106": "Firmware data is empty, unable to upgrade",
	"m107": "Device '{{. a}}' cannot connect, please check. If the problem persists, please try restarting the device",
	"m108": "File is not an upgrade package, please check",
	"m109": "Sending start packet failed",
	"m110": "Abnormal response to receive start packet",
	"m111": "Exception sending data packet, packet location:",
	"m112": "Exception while receiving data packet, packet location:",
	"m113": "Exception when sending end packet",
	"m114": "Exception when receiving end packet",
	"m115": "The device is currently being upgraded, please wait a moment",
	"m116": "Device upgrade in progress",
	"m117": "Device upgrade successful",
	"m118": "Device upgrade failed",
	"m119": "retry",
	"m120": "Waiting to start",
	"m121": "Overview of Upgrade Progress",
	"m122": "Success",
	"m123": "Failed",
	"m124": "In Progress",
	"m125": "Device Upgrade Details",
	"m126": "Due to page refresh, firmware file is missing and cannot be retried. ",
	"m127": "Other",
	"m128": "Upgrade canceled",
	"m129": "Cancelling in progress ..",
	"m130": "After canceling the upgrade, subsequent devices will stop upgrading. Are you sure you want to cancel? ",
	"m131": "Online device",
	"m132": "Offline device",
	"m133": "Reconnect device",
	"m134": "Device Name/Device Number/IP",
	"m135": "No relevant device found temporarily",
	"m136": "There are currently no devices available for operation",
	"m137": "Device ID",
	"m138": "Original controller software version",
	"m139": "Download failed, no relevant data found",
	"m140": "Operation result",
	"m141": "Device Type",
	"m142": "Please select device type",
	"m143": "Your software version currently does not support this device type, please contact the manufacturer. ",
	"m144": "HRC-803 medium frequency welding machine",
	"m145": "HRC-802",
	"m146": "HRC-A50",
	"m147": "HRC-501",
	"m148": "HRC-650 Welding Quality Monitor",
	"m149": "HRC-670 Riveting Quality Monitor",
	"m150": "HRC-62 AC welding machine",
	"m151": "Current activation code",
	"m152": "Parameter Backup",
	"m153": "Parameter Restore",
	"m154": "Device Import",
	"m155": "Device Export",
	"m156": "The device is in the process of parameter backup. Please wait.",
	"m157": "Parameter backup has been cancelled.",
	"m158": "Failed to create the backup directory. Parameter backup failed.",
	"m159": "An exception occurred during backup. Parameter backup failed.",
	"m160": "Failed to read the standard data. Parameter backup failed.",
	"m161": "Failed to create the Excel table. Parameter backup failed.",
	"m162": "Failed to read the system parameters. Parameter backup failed.",
	"m163": "The device is offline. Parameter backup failed.",
	"m164": "Overview of Parameter Backup Progress",
	"m165": "Details of Parameter Backup",
	"m166": "Device Parameter Backup in Progress",
	"m167": "Parameter backup successful.",
	"m168": "Parameter backup failed.",
	"m169": "Backup Standard Parameters",
	"m170": "Progress of Standard Parameter Backup",
	"m171": "Progress of System Parameter Backup",
	"m172": "Progress of Solder Joint Information Backup",
	"m173": "Retry upgrade task has been initiated.",
	"m174": "Retry backup task has been initiated.",
	"m175": "Cancel upgrade task has been initiated.",
	"m176": "Cancel backup task has been initiated.",
	"m177": "After cancelling the backup, subsequent devices will stop backing up. Are you sure you want to cancel?",
	"m178": "Please select a tar compressed file.",
	"m179": "Error occurred during file decompression. Please check if the file is normal.",
	"m180": "Parameter restore completed.",
	"m181": "An exception occurred during parameter restore.",
	"m182": "Overview of Parameter Restore Progress",
	"m183": "Details of Parameter Restore",
	"m184": "Device Parameter Restore in Progress",
	"m185": "Parameter restore successful.",
	"m186": "Parameter restore failed.",
	"m187": "Progress of Standard Parameter Restore",
	"m188": "Progress of System Parameter Restore",
	"m189": "Progress of Solder Joint Information Restore",
	"m190": "Exception occurred during solder joint information import.",
	"m191": "Backup has been cancelled.",
	"m192": "Parameter restore has been cancelled.",
	"m193": "The device has a backup or restore task in progress and cannot be downloaded.",
	"m194": "After cancelling the parameter restore, subsequent restores will stop. Are you sure you want to cancel?",
	"m195": "The corresponding device cannot be found in the compressed file. Please check the file.",
	"m196": "Retry parameter restore task has been initiated.",
	"m197": "The device has other tasks running and cannot be operated.",
	"m198": "Restored parameters include:",
	"m199": "Due to your activation information not activating any device type, devices cannot be added or modified temporarily",
	"m200": "This device does not currently support this operation. ",
	"m201": "Backup file",
	"m202": "The imported file does not match the device number or type. The file name prefix format must be: device number+{{.a}}",
	"m203": "Login Password",
	"m204": "Please select file",
	"m205": "After cleaning the data, it cannot be restored. Are you sure you want to clean it up? ",
	"m206": "Clean up backup",
	"m207": "Cleaning",
	"m208": "Cleanup successful",
	"m209": "Cleaning failed",
	"m210": "Device MAC Address Conflict",
	"M211": "User '{{. a}}' backed up the parameters of device '{{. b}}':",
	"m212": "Current device is open; cannot be opened again.",
	"m213": "MAC Address",
	"m214": "Expulsion Point",
	"m215": "Help",
	"p001": "New production line",
	"p002": "Edit Production Line",
	"p003": "The production line is referenced and cannot be deleted",
	"p004": "Production Line Management",
	"p005": "Production Line Name",
	"p006": "Production line remarks",
	"p007": "Successfully edited production line",
	"p008": "Successfully added production line",
	"p009": "Duplicate production line name",
	"p010": "The production line name cannot be empty, and the length cannot be less than 2",
	"p011": "Sorting must be a positive integer and cannot exceed 5 digits",
	"p012": "Paging parameter exception",
	"p013": "Abnormal acquisition of production line data, please try again later",
	"p014": "Input parameter ID exception, must be an integer",
	"p015": "Abnormal data submission",
	"p016": "Duplicate production line name, please revise and resubmit",
	"p017": "Add production line exception, please try again later",
	"p018": "Update production line exception, please try again later",
	"p019": "Check if the production line is occupied abnormally, please try again later",
	"p020": "Delete production line exception, please try again later",
	"p021": "Abnormal recovery of production line, please try again later",
	"p022": "Successfully deleted production line",
	"p023": "Successful restoration of production line",
	"p024": "Bar/Page",
	"p025": "Pre-grinding specification number",
	"p026": "Post-grinding specification number",
	"p027": "No data available",
	"p028": "Save reference curve",
	"p029": "No resistance curve data for this record",
	"p030": "Resistance curves before and after grinding for the last three days",
	"p031": "Curve data lengths before and after grinding are inconsistent; selection unavailable",
	"p032": "This record lacks resistance curve data",
	"p033": "Selected curve length does not match current chart length; selection unavailable",
	"p034": "Before Grinding",
	"p035": "After Grinding",
	"p036": "Please select a curve record first",
	"p037": "Selected record lacks resistance curve data",
	"p038": "[Reference Curve] Before Grinding",
	"p039": "[Reference Curve] After Grinding",
	"p040": "Please generate reference curve first",
	"p041": "Reference curve saved successfully",
	"p042": "Query curve reference record error",
	"p043": "Curve data anomaly",
	"p044": "Curve exceeds saved reference curve fluctuation range, generation failed",
	"p045": "Real-time curve length does not match reference curve length",
	"p046": "Real-time post-grinding curve exceeds tolerance range",
	"p047": "Grinding Settings",
	"p048": "View Grinding Settings",
	"p049": "Manage Grinding Settings",
	"p050": "Grinding Monitoring",
	"p051": "View Grinding Monitoring",
	"p052": "Manage Grinding Monitoring",
	"p053": "Save Reference Curve Fluctuation Range",
	"p054": "Monitor Reference Curve Fluctuation Range",
	"p055": "Alarm Type",
	"p056": "View",
	"p057": "[Real-time Curve] Before Grinding",
	"p058": "[Real-time Curve] After Grinding",
	"p059": "Current Reference Resistance Curve",
	"p060": "Reference Resistance Curve",
	"p061": "Preview Resistance Curve",
	"p062": "Post-grinding resistance value exceeds pre-grinding resistance value",
	"p063": "Auto-exclusion upper/lower tolerance must be greater than 0",
	"p064": "Auto-exclusion upper/lower tolerance",
	"p065": "Monitor Welding Resistance Curve Settings",
	"p066": "Enable Pre-Filter",
	"p067": "Average Resistance Before Grinding - After Grinding Greater Than",
	"p068": "Classified as Normal",
	"p069": "System Automatically Rejected Curves Exceeding Tolerance Range",
	"p070": "Upper Tolerance on Post-Grinding Curve",
	"p071": "Lower Tolerance on Post-Grinding Curve",
	"p072": "Enter pre- and post-grinding specification numbers",
	"p073": "Pre-grinding - Post-grinding resistance must be greater than 0",
	"p074": "Post-grinding curve upper/lower tolerance must be greater than 0",
	"p075": "Pre-filter exceeds normal range",
	"p076": "Software Version",
	"p077": "This feature is not supported in this version",
	"p078": "The current calibration selection is set to the system default and cannot be calibrated.",
	"u001": "User Management",
	"u002": "New User",
	"u003": "Name",
	"u004": "Role",
	"u005": "Password",
	"u006": "Edit User",
	"u007": "Viewer",
	"u008": "Operator",
	"u009": "Administrator",
	"u010": "Not activated",
	"u011": "Normal",
	"u012": "Freeze",
	"u013": "Account name must be at least three characters long",
	"u014": "Name must be at least three characters long",
	"u015": "Password must be at least three characters long",
	"u016": "Please select a role",
	"u017": "Please select status",
	"u018": "User editing successful",
	"u019": "User added successfully",
	"u020": "Abnormal user data retrieval, please try again later",
	"u021": "User deleted successfully",
	"u022": "User recovery successful",
	"u023": "Duplicate account name, please modify",
	"u024": "Adding user exception, please try again later",
	"u025": "Editing user exception, please try again later",
	"u026": "User deletion exception, please try again later",
	"u027": "Restore user exception, please try again later",
	"u028": "Operator ID",
	"u029": "Role Management",
	"u030": "New Role",
	"u031": "Abnormal obtaining role data, please try again later",
	"u032": "Duplicate role name, please modify",
	"u033": "Adding role exception, please try again later",
	"u034": "Editing role exception, please try again later",
	"u035": "Abnormal deletion of role, please try again later",
	"u036": "Abnormal role recovery, please try again later",
	"u037": "Role added successfully",
	"u038": "Character editing successful",
	"u039": "Role deleted successfully",
	"u040": "Character recovery successful",
	"u041": "Character Name",
	"u042": "Edit Role",
	"u043": "Character name cannot be empty and its length cannot be less than 2",
	"u044": "Permission",
	"u045": "Production Line",
	"u046": "Production Line View",
	"u047": "Permission Settings",
	"u048": "Device",
	"u049": "Device View",
	"u050": "Device online",
	"u051": "User",
	"u052": "User View",
	"u053": "View Specification Library",
	"u054": "Standardized Library Management",
	"u055": "System Record Viewing",
	"u056": "System Record Management",
	"u057": "System Initialization View",
	"u058": "System Initialization Management",
	"u059": "Real time monitoring and viewing",
	"u060": "Real time monitoring operation",
	"u061": "Real time monitoring and viewing",
	"u062": "Real time monitoring operation",
	"u063": "View Specification Parameters",
	"u064": "Standardized parameter operation",
	"u065": "Production Management View",
	"u066": "Production Management Operations",
	"u067": "System parameter viewing",
	"u068": "System parameter operation",
	"u069": "Welding Record View",
	"u070": "Welding Record Operation",
	"u071": "Alarm Record View",
	"u072": "Alarm Record Operation",
	"u073": "View modification records",
	"u074": "Modify Record Operation",
	"u075": "Solder Joint Management View",
	"u076": "Solder joint management operation",
	"u077": "Role View",
	"u078": "Permission setting successful",
	"u079": "Confirm Password",
	"u080": "The two password inputs are inconsistent, please re-enter! ",
	"u081": "Registration information does not have permission to obtain, please authorize first. ",
	"u082": "Registration information is missing, please activate first. ",
	"u083": "Registration information is abnormal, please register again. ",
	"u084": "The current version is a trial version. To use this software, please apply for an activation code. ",
	"u085": "Activate",
	"u086": "Product Activation",
	"u087": "Product serial number",
	"u088": "Please send the product serial number below to the merchant to obtain the activation code. ",
	"u089": "Enter activation code",
	"u090": "If you have any questions, please contact technical support. ",
	"u091": "Copy successful. ",
	"u092": "Copy failed. ",
	"u093": "Activate Product",
	"u094": "Activate View",
	"u095": "Excitation operation",
	"u096": "User level abnormal",
	"u097": "Activation code generation failed",
	"u098": "Incorrect activation code",
	"u099": "Please enter activation code",
	"u100": "Product serial number missing",
	"u102": "Invalid activation code! ",
	"u103": "Writing activation information failed, please try again later",
	"u104": "Activation successful, we will grant relevant permissions based on your activation code information. If you have any questions, please contact the manufacturer. ",
	"u105": "Change Password",
	"u106": "Old Password",
	"u107": "New Password",
	"u108": "Please enter your old password",
	"u109": "Incorrect old password",
	"u110": "Please enter your new password",
	"u111": "Password changed successfully",
	"u112": "Password change failed",
	"u113": "Display columns",
	"u114": "Select columns to display",
	"u115": "Please select at least one column to display",
	"l001": "Console",
	"l002": "Online",
	"l003": "All online",
	"l004": "All offline",
	"l005": "Alarm",
	"l006": "Offline successful",
	"l007": "Online successful",
	"l008": "Offline failure",
	"l009": "Online failure",
	"l010": "Fold All",
	"l011": "Expand All",
	"b001": "Database Management",
	"b002": "Specification Library",
	"b003": "System parameter copy",
	"b004": "Parameter Comparison",
	"b005": "Current limiting parameter",
	"b006": "Specification Number",
	"b007": "Standard Name",
	"b008": "Welding 1 minimum",
	"b009": "Welding 1 maximum",
	"b010": "Welding 2 minimum",
	"b011": "Welding 2 maximum",
	"b012": "Welding 3 minimum",
	"b013": "Welding 3 maximum",
	"b014": "Power Mode",
	"b015": "Mixed",
	"b016": "constant current",
	"b017": "Duty cycle",
	"b018": "Preloading",
	"b019": "chasing pressure",
	"b020": "Pre welding",
	"b021": "Cooling",
	"b022": "Slowly rising",
	"b023": "Welding 1",
	"b024": "Cold 1",
	"b025": "Welding 2",
	"b026": "Cold 2",
	"b027": "Welding 3",
	"b028": "gradual decrease",
	"b029": "Cooling",
	"b030": "Post weld",
	"b031": "Keep",
	"b032": "Rest",
	"b033": "Copy",
	"b034": "Reset this group",
	"b035": "Download this group specification",
	"b036": "Batch Download Specification",
	"b037": "Number of pulses for welding 2",
	"b038": "No configuration data",
	"b039": "Error in obtaining maximum specification value",
	"b040": "Standard",
	"b041": "Add specification exception, please try again later",
	"b042": "Specification added successfully",
	"b043": "Abnormal modification specification, please try again later",
	"b044": "Specification modified successfully",
	"b045": "Delete specification exception, please try again later",
	"b046": "Delete specification successfully",
	"b047": "Duplicate specification number, please modify before submitting",
	"b048": "Exception in obtaining specification number, please try again later",
	"b049": "Standard name cannot be empty",
	"b050": "Copy specification exception, please try again later",
	"b051": "Copy specification successful",
	"b052": "Please select the specification to delete",
	"b053": "Please select the specification to reset to zero",
	"b054": "Please select the specification to copy",
	"b055": "After deleting data, it cannot be recovered.Are you sure you want to delete it? ",
	"b056": "Select All",
	"b057": "Source Device",
	"b058": "Target device",
	"b059": "Download all system parameters",
	"b060": "Compare",
	"b061": "Comparison method",
	"b062": "Controller",
	"b063": "Exception in querying specification library data",
	"b064": "Operation Exception",
	"b065": "Parameter",
	"b066": "Minimum current for welding 1",
	"b067": "Welding 1 maximum current",
	"b068": "Minimum current for welding 2",
	"b069": "maximum current for welding 2",
	"b070": "Minimum current for welding 3",
	"b071": "maximum current for welding 3",
	"b072": "Preloading time",
	"b073": "Preloading pressure",
	"b074": "chasing time",
	"b075": "chasing pressure",
	"b076": "Pre welding control selection",
	"b077": "Pre welding current",
	"b078": "Pre welding time",
	"b079": "[Reserved] Pre welding pressure [KN (0-10000) or% (0-100)]",
	"b080": "cooldown time 0",
	"b081": "[Reserved] Cooling pressure 0 (KN or%)",
	"b082": "Slow rise time",
	"b083": "Welding 1 Control Selection",
	"b084": "Welding 1 current",
	"b085": "Welding time 1",
	"b086": "UIP function selection 0~1",
	"b087": "cooldown time 1",
	"b088": "[Reserved] Welding 1 pressure [KN (0-10000) or% (0-100)]",
	"b089": "Welding 2 Control Selection",
	"b090": "Welding 2 current",
	"b091": "Welding time 2",
	"b092": "Welding 2 pressure",
	"b093": "cooldown time 2",
	"b094": "UIP reference value%",
	"b095": "Welding 2 pulse number",
	"b096": "Welding 3 Control Selection",
	"b097": "Welding 3 current",
	"b098": "Welding time 3",
	"b099": "Tolerance Zone% on UIP",
	"b100": "Slow descent time",
	"b101": "Cooling time 3",
	"b102": "UIP conditional tolerance zone",
	"b103": "Rear welding control selection",
	"b104": "Post weld current",
	"b105": "Post welding time",
	"b106": "UIP conditional tolerance zone",
	"b107": "hold time",
	"b108": "UIP lower tolerance zone",
	"b109": "Rest time",
	"b110": "Resting pressure",
	"b111": "Power Control Selection (0-2) 0: Constant Current 1: Duty Cycle 2: Hybrid",
	"b112": "Splash recognition resistance threshold",
	"b113": "Controller 1",
	"b114": "Controller 2",
	"b115": "Specification Library 1",
	"b116": "Specification Library 2",
	"b117": "Download this group specification",
	"b118": "Batch Download Specification",
	"b119": "Select device number:",
	"b120": "Download to lower computer:",
	"b121": "Group",
	"b122": "Lower computer",
	"b123": "from",
	"b124": "arrived",
	"b125": "Download successful",
	"b126": "Device type retrieval error",
	"b127": "Target device specification number out of range (0- {{.a}})",
	"b128": "{{.a}} specification number does not exist ",
	"b129": "Download failed",
	"b130": "Range selection error",
	"b131": "Inconsistent download interval ({{.a}}~{{.b}})",
	"b132": "User '{{.a}}' downloaded specification number '{{.c}}' for device ID '{{.b}}'",
	"b133": "User '{{.a}}' downloaded specification numbers in bulk for device ID '{{.b}}', from '{{.c}}' to '{{.d}}' to '{{.e}}' to '{{.f}}'",
	"b134": "Please select source and target devices",
	"b135": "Confirm Operation",
	"b136": "Are you sure you want to install the device",
	"b137": "Are you sure you want to install the device【",
	"b138": "】 synchronized to the target device? ",
	"b139": "The submitted data is not a valid controller number",
	"b140": "User '{{.a}}' copied the system parameter specification from machine Id: '{{.b}}' to: '{{.c}}'",
	"b141": "Consistent specification number, unable to compare",
	"b142": "Specification number out of range (0-959)",
	"b143": "Specification number out of range (0-63)",
	"b144": "Controller not found",
	"b145": "[Reserved] Welding 1 pressure [KN (0-10000) or% (0-100)]",
	"b146": "[Reserved] Cooling pressure 2 [KN (0-10000) or% (0-100)]",
	"b147": "[Reserved] Cooling pressure 3 [KN (0-10000) or% (0-100)]",
	"b148": "[Reserved] Post weld pressure [KN (0-10000) or% (0-100)]",
	"b149": "[Reserve] Maintain pressure [KN (0-10000) or% (0-100)]",
	"b150": "Same standard, no comparison allowed",
	"b151": "{{.a}} input error",
	"b152": "Input verification error",
	"b153": "Synchronize from device to offline library",
	"b154": "Synchronize from offline library to device",
	"b155": "th",
	"b156": "Sync",
	"b157": "Range selection error",
	"b158": "User '{{.a}}' synchronizes device ID '{{.b}}' from device '{{.c}}' to offline library specification '{{.d}}'",
	"b159": "Synchronization successful",
	"b160": "Synchronization failed",
	"b161": "User {{.a}} saving offline library specification for device ID {{.b}}: {{.c}}",
	"b162": "Saved successfully",
	"b163": "Save failed",
	"b164": "User {{.a}} synchronizes device ID {{.b}} offline library to specification: {{.c}}",
	"b165": "Export specification parameters",
	"b166": "Pre welding control mode",
	"b167": "Welding 1 Control Mode",
	"b168": "Welding 2 Control Mode",
	"b169": "Welding 3 Control Mode",
	"b170": "Rear Welding Control Mode",
	"b171": "Importing will overwrite the original data.Are you sure you want to import? ",
	"b172": "This file cannot be imported to this device",
	"b173": "User {{.a}} imports specification for device ID {{.b}}: {{.c}}",
	"b174": "User {{.a}} imports offline library specification for device ID {{.b}}: {{.c}}",
	"b175": "Import completed, a total of {{.a}} items imported",
	"b176": "Details",
	"b177": "Please select the record to delete",
	"b178": "Record deletion failed",
	"b179": "Record deleted successfully",
	"b180": "Are you sure you want to delete the selected record? ",
	"b181": "Confirm",
	"b182": "Cancel",
	"b183": "Abnormal acquisition of welding record data, please try again later",
	"b184": "Current Usage Specification Number",
	"b185": "Current Work Stage",
	"b186": "Current stage running time",
	"b187": "Record does not exist",
	"b188": "Search failed, no relevant welding curve found",
	"b189": "Abnormal retrieval of alarm record data, please try again later",
	"b190": "Exception in obtaining modification record data, please try again later",
	"b191": "Specification Details",
	"b192": "Please click the 'Download' button to activate the 'Reset' function! ",
	"b193": "Pressure exceeds range",
	"b194": "Plate thickness exceeds range",
	"b195": "line",
	"b196": "already exists",
	"b197": "There are other tasks in progress, currently unable to process",
	"b198": "Solder joint management import operation successful",
	"b199": "Solder joint management import operation failed",
	"b200": "Solder joint management verification operation successful",
	"b201": "Solder joint management verification operation failed",
	"b202": "Solder joint management clearing operation successful",
	"b203": "Solder joint management clearing operation failed",
	"b204": "Pressure exceeds range (0-65535)",
	"b205": "Plate thickness exceeds the range (0-655.35)",
	"b206": "Please select a specification! If no specification exists, please add one.",
	"b207": "Solder joint management import operation successful",
	"b208": "Solder Joint Management Import Operation Failed",
	"b209": "Failed to delete local weld point data",
	"b210": "Failed to create solder joint",
	"b211": "Missing start parameter!",
	"b212": "The start parameter can only be an integer!",
	"b213": "Missing end parameter!",
	"b214": "The end parameter can only be an integer!",
	"b215": "Pulse Width Reference Value",
	"b216": "accumulated pulse width value",
	"b217": "Pulse Width Count Value",
	"b218": "Solder joint management download operation failed",
	"r001": "Device Status",
	"r002": "Work",
	"r003": "Grinding",
	"r004": "Welding",
	"r005": "Check",
	"r006": "Pressure Test",
	"r007": "Trial Welding",
	"r008": "Alarm",
	"r009": "Alarm Record View",
	"r010": "IO Status",
	"r011": "Welding waveform",
	"r012": "Controller Information",
	"r013": "Real time data",
	"r014": "Single piece solder joint count",
	"r015": "Class output",
	"r016": "Total production quantity",
	"r017": "Total number of welding points",
	"r018": "Step increased number",
	"r019": "number of grinded",
	"r020": "Bus voltage",
	"r021": "Current standard splash count value",
	"r022": "Total splash count value",
	"r023": "Controller Hardware Version",
	"r024": "System software version",
	"r025": "CPLD software version",
	"r026": "BOOT version",
	"r027": "Electrode",
	"r028": "Input",
	"r029": "Output",
	"r030": "Start Signal 1",
	"r031": "Start signal 2",
	"r032": "Program Selection 1",
	"r033": "Program Selection 2",
	"r034": "Program Selection 4",
	"r035": "Program Selection 8",
	"r036": "Program Selection 16",
	"r037": "Program Selection 32",
	"r038": "Inspection/Welding",
	"r039": "Alarm Reset",
	"r040": "Work/Grinding",
	"r041": "Emergency Stop",
	"r042": "Transformer temperature switch",
	"r043": "Inverter temperature switch",
	"r044": "Water flow switch",
	"r045": "Air pressure switch",
	"r046": "Welding allowed",
	"r047": "Reserved",
	"r048": "Count reset",
	"r049": "Program 64",
	"r050": "Program 128",
	"r051": "Program 256",
	"r052": "Program 512",
	"r053": "Confirmation of electrode grinding",
	"r054": "Confirmation of electrode replacement",
	"r055": "Reserve 28",
	"r056": "Retain 29",
	"r057": "Reserve 30",
	"r058": "Retain 31",
	"r059": "Machine ready",
	"r060": "Air Valve 1",
	"r061": "Air valve 2",
	"r062": "Air valve 3",
	"r063": "Air valve 4",
	"r064": "Welding completed",
	"r065": "IGBT trigger",
	"r066": "Welding Request",
	"r067": "Motor output",
	"r068": "Alarm output",
	"r069": "Electrode grinding",
	"r070": "Electrode replacement",
	"r071": "Grinding valve",
	"r072": "Action completed",
	"r073": "Reserve 20",
	"r074": "Retain 21",
	"r075": "Retain 22",
	"r076": "Retain 23",
	"r077": "Reserve 24",
	"r078": "Reserve 25",
	"r079": "Retain 26",
	"r080": "Reserve 27",
	"r081": "Current",
	"r082": "Voltage",
	"r083": "Resistance",
	"r084": "Pressure",
	"r085": "Collection Settings",
	"r086": "Settings",
	"r087": "Collect current curve",
	"r088": "Collect resistance curve",
	"r089": "Collect voltage curve",
	"r090": "Collect pressure curve",
	"r091": "Setting successful",
	"r092": "Failed to update collection curve",
	"r093": "Updated collection curve successfully",
	"r094": "Operation type not known",
	"r095": "Invalid device number",
	"r096": "The device is offline and operation is not allowed",
	"r097": "Operation successful",
	"r098": "Operation failed",
	"r099": "{{.a}} unknown operation",
	"r100": "Display parameter data not found",
	"r101": "Welding Data",
	"r102": "Statistical Data",
	"r103": "Count",
	"r104": "View",
	"r105": "Welding Record Number",
	"r106": "Controller software version",
	"r107": "Solder joint management refresh operation successful",
	"r108": "Solder joint management refresh operation failed",
	"r109": "Import will merge with existing data, are you sure you want to import? ",
	"r110": "Abnormal inquiry of solder joint information",
	"r111": "This operation is not allowed in trial welding or pressure testing mode",
	"r112": "In the grinding mode, this operation is not allowed.",
	"r113": "In functional development",
	"r114": "Graphics support box selection range for zooming in, double-click the mouse to restore default size",
	"r115": "Unable to read system files",
	"r116": "Confirm New Solder Joint",
	"r117": "Select New Solder Joint",
	"r118": "Splash point display",
	"s001": "System Record",
	"s002": "Number",
	"s003": "Operator",
	"s004": "Object Number",
	"s005": "Summary",
	"s006": "Operation time",
	"s007": "Scale Stage Status",
	"s008": "Stage Selection",
	"s009": "Enable controller ready, start normal operation",
	"s010": "Enable controller welding",
	"s011": "Status of upper computer I/O port",
	"s012": "Error Clearing Command",
	"s013": "Current PWM output setting value",
	"s014": "Electrode pressure output setting value",
	"s015": "Bus voltage display value",
	"s016": "Primary current display value",
	"s017": "Secondary current display value",
	"s018": "Electrode pressure display value",
	"s019": "Welding counter reset command",
	"s020": "Profibus input port status word 00",
	"s021": "Profibus input port status word 01",
	"s022": "Profibus output port status word 00",
	"s023": "Profibus output port status word 01",
	"s024": "Devicenet input port status word 00",
	"s025": "Devicenet input port status word 01",
	"s026": "Devicenet output port status word 00",
	"s027": "Devicenet output port status word 00",
	"s028": "Click or drag and drop files to upload here",
	"s029": "Import completed",
	"s030": "Refresh",
	"s031": "Verification",
	"s032": "Clear",
	"s033": "New solder joint",
	"s034": "Edit solder joint",
	"s035": "Reserved",
	"s036": "Address pointer for filling in historical alarm records",
	"s037": "Alarm Status Word (0~31)",
	"s038": "Pre welding pressure",
	"s039": "Cooling pressure 0",
	"s040": "Slowly increasing pressure",
	"s041": "Welding 1 pressure",
	"s042": "Cooling pressure 1",
	"s043": "Cooling pressure 2",
	"s044": "Welding 3 pressure",
	"s045": "Slowly reduce pressure",
	"s046": "Cooling pressure 3",
	"s047": "Post weld pressure",
	"s048": "Maintain pressure",
	"s049": "Model number of welding tongs 1 being produced, field 00 (stored as ASCII code value)",
	"s050": "Model number of welding tongs 1 being produced, field 01 (stored as ASCII code value)",
	"s051": "Model number of welding tongs 1 being produced, field 02 (stored as ASCII code value)",
	"s052": "Model number of welding tongs 1 being produced, field 03 (stored as ASCII code value)",
	"s053": "Model number of welding tongs 2 being produced, field 00 (stored as ASCII code value)",
	"s054": "Model number of welding tongs 2 being produced, field 01 (stored as ASCII code value)",
	"s055": "Model number of welding tongs 2 being produced, field 02 (stored as ASCII code value)",
	"s056": "Model number of welding tongs 2 in production, field 03 (stored as ASCII code value)",
	"s057": "Electrode Pressure Mode",
	"s058": "Is the startup 2 function selected",
	"s059": "Selection of solder joint confirmation function",
	"s060": "number of welding repairs",
	"s061": "Test pressure",
	"s062": "Controller CPLD software version",
	"s063": "Communication interface selection",
	"s064": "Communication Address",
	"s065": "Network Function",
	"s066": "IP0",
	"s067": "IP1",
	"s068": "Device Serial Number",
	"s069": "DeviceNet BaudRate",
	"s070": "rated voltage",
	"s071": "Number of inverters",
	"s072": "Welding allows function selection",
	"s073": "Transformer turns ratio",
	"s074": "Transformer efficiency",
	"s075": "Constant current control mode",
	"s076": "Primary current threshold",
	"s077": "IGBT protection alarm reset control",
	"s078": "HMI emergency stop function selection",
	"s079": "Program group prioritizes feature selection",
	"s080": "Selection of proportional valve function",
	"s081": "Selection of controller offline operation function without HMI",
	"s082": "Large opening work trigger mode",
	"s083": "Electrode grinding confirmation function",
	"s084": "When hanging welding, the welding tongs are slowly opened and delayed to start",
	"s085": "Proportional coefficient between the sampled current value and the actual current value of the Rogowski coil in welding tongs 1",
	"s086": "Proportional coefficient between the sampled current value of the 2Rogowski coil of the welding tongs and the actual current value",
	"s087": "Proportional coefficient between the sampled current value of the 1CT coil of the welding tongs and the actual current value",
	"s088": "Proportional coefficient between the sampled current value of the 2CT coil of the welding tongs and the actual current value",
	"s089": "System welding tongs 1 support actual maximum current",
	"s090": "System welding tongs 2 support actual maximum current",
	"s091": "Current power factor angle of system welding tongs 1",
	"s092": "Current power factor angle of system welding tongs 2",
	"s093": "System current welding trigger control angle",
	"s094": "For the electrode arm opening state after the suspension welding controller is powered off",
	"s095": "Welding completion signal and action completion signal output mode",
	"s096": "Bus voltage display coefficient, no need to set this parameter now",
	"s097": "Minimum primary current PWM output setting value for welding tongs 1",
	"s098": "Primary current PWM output setting value for welding tongs 1",
	"s099": "Setting value of PWM output for primary current of welding tongs 1 in the second stage",
	"s100": "Welding tongs 1 three-stage primary current PWM output setting value",
	"s101": "Welding tongs 1 four stage primary current PWM output setting value",
	"s102": "Welding tongs 1 five stage primary current PWM output setting value",
	"s103": "Welding tongs 1 six stage primary current PWM output setting value",
	"s104": "Maximum primary current PWM output setting value for welding tongs 1",
	"s105": "Sampling value of primary minimum current for welding tongs 1",
	"s106": "Sampling value of primary current of welding tongs 1",
	"s107": "Sampling value of primary two-stage current for welding tongs 1",
	"s108": "Sampling value of primary three-stage current for welding tongs 1",
	"s109": "Sampling value of primary four stage current for welding tongs 1",
	"s110": "Sampling value of primary five stage current for welding tongs 1",
	"s111": "Sampling value of primary six stage current for welding tongs 1",
	"s112": "Sampling value of primary maximum current for welding tongs 1",
	"s113": "Primary minimum current display value of welding tongs 1",
	"s114": "Primary current display value of welding tongs 1",
	"s115": "Display value of primary two-stage current for welding tongs 1",
	"s116": "Primary three-stage current display value of welding tongs 1",
	"s117": "Primary four stage current display value of welding tongs 1",
	"s118": "Primary five stage current display value of welding tongs 1",
	"s119": "Primary six stage current display value of welding tongs 1",
	"s120": "Primary maximum current display value of welding tongs 1",
	"s121": "Minimum secondary current PWM output setting value for welding tongs 1",
	"s122": "Secondary current PWM output setting value for welding tongs 1",
	"s123": "PWM output setting value for secondary current of welding tongs 1",
	"s124": "Setting value of PWM output for three-stage secondary current of welding tongs 1",
	"s125": "Welding tongs 1 four stage secondary current PWM output setting value",
	"s126": "Welding tongs 1 five stage secondary current PWM output setting value",
	"s127": "Welding tongs 1 six stage secondary current PWM output setting value",
	"s128": "Maximum secondary current PWM output setting value for welding tongs 1",
	"s129": "Sampling value of secondary minimum current for welding tongs 1",
	"s130": "Sampling value of secondary current in welding tongs 1",
	"s131": "Sampling value of secondary two-stage current of welding tongs 1",
	"s132": "Sampling value of secondary three-stage current of welding tongs 1",
	"s133": "Sampling value of secondary four segment current of welding tongs 1",
	"s134": "Sampling value of secondary five segment current of welding tongs 1",
	"s135": "Sampling value of secondary six segment current of welding tongs 1",
	"s136": "Sampling value of maximum secondary current of welding tongs 1",
	"s137": "Welding tongs 1 secondary minimum current display value",
	"s138": "Secondary current display value of welding tongs 1",
	"s139": "Secondary two-stage current display value of welding tongs 1",
	"s140": "Secondary three-stage current display value of welding tongs 1",
	"s141": "Secondary four segment current display value of welding tongs 1",
	"s142": "Secondary five segment current display value of welding tongs 1",
	"s143": "Secondary six segment current display value of welding tongs 1",
	"s144": "Secondary maximum current display value of welding tongs 1",
	"s145": "Minimum secondary current PWM output setting value for welding tongs 2",
	"s146": "Secondary current PWM output setting value for welding tongs 2",
	"s147": "Setting value of secondary current PWM output for welding tongs 2",
	"s148": "Setting value of PWM output for three-stage secondary current of welding tongs 2",
	"s149": "Welding tongs 2 four stage secondary current PWM output setting value",
	"s150": "Welding tongs 2 five stage secondary current PWM output setting value",
	"s151": "Welding tongs 2 six stage secondary current PWM output setting value",
	"s152": "Maximum secondary current PWM output setting value for welding tongs 2",
	"s153": "Sampling value of secondary minimum current for welding tongs 2",
	"s154": "Sampling value of secondary current of welding tongs 2",
	"s155": "Sampling value of secondary two-stage current of welding tongs 2",
	"s156": "Sampling value of secondary three-stage current of welding tongs 2",
	"s157": "Sampling value of secondary four segment current of welding tongs 2",
	"s158": "Sampling value of secondary five segment current of welding tongs 2",
	"s159": "Sampling value of secondary six segment current of welding tongs 2",
	"s160": "Sampling value of maximum secondary current for welding tongs 2",
	"s161": "Secondary minimum current display value of welding tongs 2",
	"s162": "Secondary current display value of welding tongs 2",
	"s163": "Secondary two-stage current display value of welding tongs 2",
	"s164": "Secondary three-stage current display value of welding tongs 2",
	"s165": "Secondary four segment current display value of welding tongs 2",
	"s166": "Secondary five segment current display value of welding tongs 2",
	"s167": "Secondary six segment current display value of welding tongs 2",
	"s168": "Secondary maximum current display value of welding tongs 2",
	"s169": "Pressure output set value for electrode section 1 of welding tongs",
	"s170": "Set value of electrode two-stage pressure output for welding tongs 1",
	"s171": "Actual measured value of pressure display on electrode section 1 of welding tongs",
	"s172": "Actual measured value of pressure display on electrode segment 2 of welding tongs 1",
	"s173": "Set value for pressure output of electrode 1 of welding tongs 2",
	"s174": "Set value of electrode two-stage pressure output for welding tongs 2",
	"s175": "Actual measured value of pressure display on electrode section 2 of welding tongs",
	"s176": "Actual measured value of pressure display for electrode segment 2 of welding tongs",
	"s177": "Selection of primary current calibration parameters",
	"s178": "Selection of secondary current calibration parameters",
	"s179": "Welding specification selection mode",
	"s180": "Welding tongs 1 primary constant current fine adjustment parameter",
	"s181": "Secondary constant current fine adjustment parameter for welding tongs 1",
	"s182": "Welding tongs 2 primary constant current fine-tuning parameters",
	"s183": "Secondary constant current fine adjustment parameter for welding tongs 2",
	"s184": "B Welding Clamp Repair Mold Upward Pressure",
	"s185": "B Welding Clamp Grinding Pressure",
	"s186": "Selection of welding point control function for welding tongs 1 process",
	"s187": "Selection of Welding Point Control Function for Welding Clamp 2 Process",
	"s188": "The number of solder joints per piece meets the selection of process solder point alarm function",
	"s189": "Selection of solder joint counting alarm function for shift production",
	"s190": "Timing immediately after alarm reset",
	"s191": "Determination time of end of current welding cycle for welding tongs 1",
	"s192": "Determination time of end of current welding cycle for welding tongs 2",
	"s193": "Lower limit setting value for the number of welding points per piece of welding tongs 1",
	"s194": "Lower limit setting value for the number of welding points per piece of welding tongs 2",
	"s195": "Upper limit setting value for the number of welding points per piece of welding tongs 1",
	"s196": "Upper limit setting value for the number of welding points per piece of welding tongs 2",
	"s197": "Set output value for welding tongs shift 1",
	"s198": "Set output value for welding tongs shift 2",
	"s199": "Number of single weld points for welding tongs 1",
	"s200": "Number of single welding points for welding tongs 2",
	"s201": "Counter power failure saves alarm information value",
	"s202": "Welding tongs configuration mode",
	"s203": "Setting value for one-step increase of welding tongs",
	"s204": "Setting value for two-step increase of welding tongs",
	"s205": "Setting value for grinding frequency of welding tongs 1",
	"s206": "Set value for the number of grinding times of welding tongs 2",
	"s207": "Welding tongs 1 grinding pre warning welding point setting value",
	"s208": "Welding tongs 2 grinding pre warning welding point setting value",
	"s209": "Welding tongs increase welding points by 1 step",
	"s210": "Welding tongs 1 power compensation 1",
	"s211": "Welding tongs 1 pressure compensation 1",
	"s212": "Welding tongs increase welding points by 2 in 1 step",
	"s213": "Welding tongs 1 power compensation 2",
	"s214": "Welding tongs 1 pressure compensation 2",
	"s215": "Welding tongs increase welding points by 3 in 1 step",
	"s216": "Welding tongs 1 power compensation 3",
	"s217": "Welding tongs 1 pressure compensation 3",
	"s218": "Welding tongs increase welding points by 4 in 1 step",
	"s219": "Welding tongs 1 power compensation 4",
	"s220": "Welding tongs 1 pressure compensation 4",
	"s221": "Welding tongs increase welding points by 5 in 1 step",
	"s222": "Welding tongs 1 power compensation 5",
	"s223": "Welding tongs 1 pressure compensation 5",
	"s224": "Welding tongs increase welding points by 6 in 1 step",
	"s225": "Welding tongs 1 power compensation 6",
	"s226": "Welding tongs 1 pressure compensation 6",
	"s227": "Welding tongs increase welding points by 7 in 1 step",
	"s228": "Welding tongs 1 power compensation 7",
	"s229": "Welding tongs 1 pressure compensation 7",
	"s230": "Welding tongs increase welding points by 8 in 1 step",
	"s231": "Welding tongs 1 power compensation 8",
	"s232": "Welding tongs 1 pressure compensation 8",
	"s233": "Welding tongs increase welding points by 9 in 1 step",
	"s234": "Welding tongs 1 power compensation 9",
	"s235": "Welding tongs 1 pressure compensation 9",
	"s236": "Welding tongs 2 steps increase welding points 1",
	"s237": "Welding tongs 2 power compensation 1",
	"s238": "Welding tongs 2 pressure compensation 1",
	"s239": "Welding tongs increase welding points by 2 steps",
	"s240": "Welding tongs 2 power compensation 2",
	"s241": "Welding tongs 2 pressure compensation 2",
	"s242": "Welding tongs 2 steps increase welding points 3",
	"s243": "Welding tongs 2 power compensation 3",
	"s244": "Welding tongs 2 pressure compensation 3",
	"s245": "Welding tongs 2 steps increase welding points 4",
	"s246": "Welding tongs 2 power compensation 4",
	"s247": "Welding tongs 2 pressure compensation 4",
	"s248": "Welding tongs increase welding points by 5 in 2 steps",
	"s249": "Welding tongs 2 power compensation 5",
	"s250": "Welding tongs 2 pressure compensation 5",
	"s251": "Welding tongs increase welding points by 6 in 2 steps",
	"s252": "Welding tongs 2 power compensation 6",
	"s253": "Welding tongs 2 pressure compensation 6",
	"s254": "Welding tongs increase welding points by 7 in 2 steps",
	"s255": "Welding tongs 2 power compensation 7",
	"s256": "Welding tongs 2 pressure compensation 7",
	"s257": "Welding tongs increase welding points by 8 in 2 steps",
	"s258": "Welding tongs 2 power compensation 8",
	"s259": "Welding tongs 2 pressure compensation 8",
	"s260": "Welding tongs increase welding points by 9 in 2 steps",
	"s261": "Welding tongs 2 power compensation 9",
	"s262": "Welding tongs 2 pressure compensation 9",
	"s263": "Minimum primary current PWM output setting value for welding tongs 2",
	"s264": "Setting value of primary current PWM output for welding tongs 2",
	"s265": "Welding tongs 2 two-stage primary current PWM output setting value",
	"s266": "Welding tongs 2 three-stage primary current PWM output setting value",
	"s267": "Welding tongs 2 four stage primary current PWM output setting value",
	"s268": "Welding tongs 2 five stage primary current PWM output setting value",
	"s269": "Welding tongs 2 six stage primary current PWM output setting value",
	"s270": "Maximum primary current PWM output setting value for welding tongs 2",
	"s271": "Sampling value of primary minimum current for welding tongs 2",
	"s272": "Sampling value of primary current for welding tongs 2",
	"s273": "Sampling value of primary two-stage current for welding tongs 2",
	"s274": "Sampling value of primary three-stage current for welding tongs 2",
	"s275": "Sampling value of primary four stage current for welding tongs 2",
	"s276": "Sampling value of primary five stage current for welding tongs 2",
	"s277": "Sampling value of primary six stage current for welding tongs 2",
	"s278": "Sampling value of primary maximum current for welding tongs 2",
	"s279": "Welding tongs 2 primary minimum current display value",
	"s280": "Display value of primary current for welding tongs 2",
	"s281": "Display value of primary two-stage current for welding tongs 2",
	"s282": "Display value of primary three-stage current for welding tongs 2",
	"s283": "Primary four stage current display value of welding tongs 2",
	"s284": "Primary five stage current display value of welding tongs 2",
	"s285": "Primary six stage current display value of welding tongs 2",
	"s286": "Welding tongs 2 primary maximum current display value",
	"s287": "Counter power failure saves alarm information value high by 16 bits",
	"s288": "Selection of UIR adjustment function",
	"s289": "Selection of Welding Time Extension Function during UIR Adjustment",
	"s290": "UIR adjustment starting time point",
	"s291": "UIR adjusts the maximum percentage of current increase",
	"s292": "Maximum percentage decrease in current adjustment for UIR",
	"s293": "Maximum percentage increase in UIR adjustment time",
	"s294": "Conversion coefficient of secondary voltage sampling value to display value",
	"s295": "Selection of UIR monitoring function",
	"s296": "Selection of SDCARD welding record function",
	"s297": "Number of welding records in one SDCARD file",
	"s298": "Number of welding files in one folder of SDCARD",
	"s299": "Suspension welding with large opening dual electronic control function",
	"s300": "Secondary resistance monitoring 0: Off 1: On",
	"s301": "Global selection of resistance threshold parameter 0: Off 1: On",
	"s302": "Internal offset address",
	"s303": "Bus voltage value during current calibration",
	"s304": "Secondary voltage in-situ detection",
	"s305": "Time Range",
	"s306": "Within 30 days",
	"s307": "Within 60 days",
	"s308": "Within 90 days",
	"s309": "Curve",
	"s310": "Abnormal time range",
	"s311": "Successfully set activity curve",
	"s312": "The selected curve is not a valid value",
	"s313": "Invalid curve number",
	"s314": "Unable to find the corresponding curve, deletion failed",
	"s315": "Delete failed",
	"s316": "Deletion successful",
	"s317": "Too few samples, unable to generate reference curve",
	"s318": "Are you sure you want to download the current reference curve to the controller? ",
	"s319": "Are you sure you want to save the current reference curve to the specification library? ",
	"s320": "Reference curve not generated, unable to download",
	"s321": "Invalid specification number (0~143)",
	"s322": "Curve data error",
	"s323": "The reference curve data is empty and cannot be saved",
	"s324": "Reference curve processing error",
	"s325": "Save reference curve error",
	"s326": "Alarm List",
	"s327": "Execution failed",
	"s328": "Execution successful",
	"s329": "Verification failed",
	"s330": "In progress ..",
	"s331": "Since the current threshold mode is set to percentage mode, {{.a}} can only be configured as an integer.Please verify.If the changes have not taken effect, please reconnect the device",
	"s332": "Currently in debug mode, please turn off debug before leaving",
	"s333": "Current Algorithm Adjustment Mode",
	"s334": "Quick",
	"s335": "End Point",
	"s336": "System Configuration",
	"s337": "Number of parallel processing for device parameter backup/restore",
	"s338": "HRC-670 Save file directory",
	"s339": "HRC-670 connection port number",
	"s340": "System Configuration View",
	"s341": "System Configuration Management",
	"s342": "Save parameter exception, please try again later",
	"s343": "Get system configuration exception, please try again later",
	"s344": "Device saved successfully",
	"s345": "HRC-670 save file directory cannot be empty",
	"s346": "HRC-670 save file directory path does not exist! ",
	"s347": "The number of parallel processing for device parameter backup/restore must be a positive integer",
	"s348": "The range of parallel processing for device parameter backup/restore needs to be within (1-8)",
	"s349": "Weld-free ID compatibility",
	"i001": "Data management",
	"i002": "Clean Data",
	"i003": "Welding Record",
	"i004": "Curve Record",
	"i005": "Alarm Record",
	"i006": "UIR reference curve",
	"i007": "Standard Library Data",
	"i008": "Standardized Cache Data",
	"i009": "System Cache Data",
	"i010": "Modify Record",
	"i011": "System Record",
	"i012": "Attention: After erasing data, it will be permanently unrecoverable. It is strongly recommended to back up the data before erasing it!! ",
	"i013": "User '{{. a}}' erases {{. b}} data",
	"i014": "Data erasure successful",
	"i015": "Data erasure failed",
	"i016": "Clean by Time",
	"i017": "1 month",
	"i018": "3 months",
	"i019": "6 months",
	"i020": "1 year",
	"i021": "Cleaning time:",
	"i022": "Non time cleaning",
	"i023": "User '{{.a}}' cleaned {{.b}} data, cleaning scope:",
	"i024": "Automatic backup of device parameters",
	"i025": "After enabling automatic backup on the device, please select the automatic backup time",
	"i026": "Automatically clean data records",
	"i027": "Enable automatic cleanup. Please select the records to be automatically cleaned up.",
	"i028": "Enable automatic cleanup. Please select the time range for automatic cleanup.",
	"i029": "이 페이지의 정리 기능은 수동으로 한 번만 수행됩니다. 자동 정리를 원하시면 '시스템 -> 시스템 설정'으로 이동하여 “데이터 기록 유지”를 활성화한 후, 변경 사항을 저장해야 적용됩니다.",
	"h001": "User {{.a}} updated the specification library '{{.b}}' (specification name: {{.c}})",
	"h002": "Abnormal retrieval of system record data, please try again later",
	"h003": "User {{.a}} created a new specification library '{{.b}}' (specification name: {{.c}})",
	"h004": "User {{.a}} deleted the specification library '{{.b}}' (specification name: {{.c}})",
	"h005": "User {{.a}} has created a new production line '{{.b}}'",
	"h006": "User {{.a}} updated production line '{{.b}}'",
	"h007": "User {{.a}} deleted production line '{{.b}}'",
	"h008": "User {{.a}} has restored the production line '{{.b}}'",
	"h009": "User {{.a}} created a new device '{{.b}}'",
	"h010": "User {{.a}} updated device '{{.b}}'",
	"h011": "User {{.a}} deleted device {{.b}}",
	"h012": "User {{.a}} restored device {{.b}}",
	"h013": "User {{.a}} created a new user '{{.b}}'",
	"h014": "User {{.a}} updated user {{.b}}",
	"h015": "User {{.a}} deleted user {{.b}}",
	"h016": "User {{.a}} restored user {{.b}}",
	"h017": "Due to more than ({{.a}}) incorrect login password attempts, account {{.b}} (Name:) has been frozen for 20 minutes",
	"h018": "User {{.a}} logged in successfully",
	"h019": "User '{{.a}}' updated the curve collection settings for device '{{.b}}'",
	"h020": "User '{{.a}}' created a new role '{{.b}}'",
	"h021": "User '{{.a}}' updated role '{{.b}}'",
	"h022": "User '{{.a}}' deleted role '{{.b}}'",
	"h023": "User '{{.a}}' restored role '{{.b}}'",
	"h024": "User '{{.a}}' changed the permissions of role '{{.b}}'",
	"k001": "Real time monitoring",
	"k002": "Standard Parameters",
	"k003": "Production Management",
	"k004": "System Parameters",
	"k005": "Welding Record",
	"k006": "Alarm Record",
	"k007": "Modify Record",
	"k008": "Solder Joint Management",
	"k009": "Device side",
	"k010": "Offline Library",
	"k011": "Welding tongs selection",
	"k012": "Splash count value",
	"k013": "Splash recognition threshold",
	"k014": "Splash Time Zone Threshold",
	"k015": "Resistance reference value",
	"k016": "Minimum threshold for welding resistance",
	"k017": "Maximum threshold for welding resistance",
	"k018": "Invalid specification number",
	"k019": "Specification {{.a}} successfully loaded from device",
	"k020": "Specification {{.a}} failed to load from device",
	"k021": "Specification {{.a}} successfully loaded from offline database",
	"k022": "Specification {{.a}} failed to load from offline database",
	"k023": "Download",
	"k024": "Equipment ->Library",
	"k025": "Export",
	"k026": "Import",
	"k027": "Electrode 1 Calibration",
	"k028": "Electrode 2 Calibration",
	"k029": "Electrode 3 calibration",
	"k030": "Electrode 4 calibration",
	"k031": "Electrode 5 Calibration",
	"k032": "UIR Settings",
	"k033": "UIR curve",
	"k034": "UIP Rectangle Diagram",
	"k035": "Software Upgrade",
	"k036": "System Backup",
	"k037": "Welding machine configuration",
	"k038": "Welding machine type",
	"k039": "Ordinary spot welding",
	"k040": "Robot spot welding",
	"k041": "Ordinary seam welding",
	"k042": "Special seam welding",
	"k043": "Suspension Welding",
	"k044": "Custom Welding",
	"k045": "convex welding",
	"k046": "BYD suspension welding",
	"k047": "Solder joint confirmation",
	"k048": "Close",
	"k049": "ON",
	"k050": "Transformer type",
	"k051": "Confirmation of electrode grinding",
	"k052": "Welding completion signal",
	"k053": "Pulse type",
	"k054": "level type",
	"k055": "Current Threshold Mode Selection",
	"k056": "Absolute Value Mode",
	"k057": "Percentage Mode",
	"k058": "UIP alarm mode",
	"k059": "Prompt",
	"k060": "Shutdown",
	"k061": "Minimum Bus Voltage",
	"k062": "Continuous Welding Mode",
	"k063": "Reference Bus Voltage",
	"k064": "Constant current control",
	"k065": "Secondary constant current",
	"k066": "Primary constant current",
	"k067": "Maximum electrode pressure",
	"k068": "Inverter output frequency",
	"k069": "Function Settings",
	"k070": "HMI emergency stop",
	"k071": "Proportional valve function",
	"k072": "Standard priority",
	"k073": "Host disconnected from HMI",
	"k074": "Initial Settings",
	"k075": "Scale selection",
	"k076": "Calibration electrode pressure",
	"k077": "Calibrate primary current",
	"k078": "Calibrate secondary current",
	"k079": "Calibration value",
	"k080": "Set value%",
	"k081": "measured value KN",
	"k082": "Function Selection",
	"k083": "UIR Monitoring",
	"k084": "Time compensation",
	"k085": "Starting time",
	"k086": "Functional Parameters",
	"k087": "Current regulation upper limit",
	"k088": "Lower limit of current regulation",
	"k089": "Splash Time Zone Threshold",
	"k090": "Splash recognition threshold",
	"k091": "Time extension upper limit",
	"k092": "Secondary voltage coefficient",
	"k093": "Global selection of resistance threshold parameters",
	"k094": "Secondary resistance monitoring",
	"k095": "Minimum threshold for welding resistance",
	"k096": "Maximum threshold for welding resistance",
	"k097": "Time extension upper limit",
	"k098": "Stop recording UIR",
	"k099": "number of solder joints",
	"k100": "Select varicose veins",
	"k101": "Welding time",
	"k102": "solder joint number",
	"k103": "Delete Curve",
	"k104": "Generate reference curve",
	"k105": "->Controller",
	"k106": "UIP Function Selection",
	"k107": "UIP reference value",
	"k108": "Tolerance Zone on UIP",
	"k109": "UIP lower tolerance zone",
	"k110": "Controller Upgrade",
	"k111": "Explanation: Please do not power off during the controller upgrade process",
	"k112": "firmware",
	"k113": "Please select the firmware file to upgrade",
	"k114": "Select File",
	"k115": "Upgrade",
	"k116": "Factory reset",
	"k117": "Description: The controller will be reset to factory settings, and the original data will be lost",
	"k118": "Options",
	"k119": "System Parameters",
	"k120": "Recovery",
	"k121": "Calibration parameter",
	"k122": "Secondary circuit impedance",
	"k123": "Welding allowed",
	"k124": "Maximum secondary current",
	"k125": "Pressure output mode",
	"k126": "Maximum welding time",
	"k127": "Maximum range of pulse width variation",
	"k128": "Normal impedance",
	"k129": "Excessive impedance",
	"k130": "small impedance",
	"k131": "IO Control Function",
	"k132": "Controller priority",
	"k133": "RS-485 priority",
	"k134": "DeviceNet priority",
	"k135": "MBTCP priority",
	"k136": "ABCC priority",
	"k137": "Work mode priority",
	"k138": "Programmer priority",
	"k139": "Effective Priority",
	"k140": "Standard group priority",
	"k141": "UIP Settings",
	"k142": "Successfully loaded from device",
	"k143": "Successfully loaded from offline library",
	"k144": "Failed to load from device",
	"k145": "Loading from offline library failed",
	"k146": "Secondary voltage detection",
	"k147": "Secondary voltage detection",
	"k148": "UIR Adjustment",
	"k149": "Inverter frequency",
	"k150": "Primary current calibration selection",
	"k151": "System default",
	"k152": "User self calibration",
	"k153": "Inverter frequency",
	"k154": "Primary fine-tuning coefficient",
	"k155": "Secondary current calibration selection",
	"k156": "PWM setting",
	"k157": "measured value (KA)",
	"k158": "Sample value",
	"k159": "Primary fine-tuning coefficient",
	"k160": "Secondary fine-tuning coefficient",
	"k161": "Secondary fine-tuning coefficient",
	"k162": "Primary calibration value",
	"k163": "Secondary calibration value",
	"k164": "Electrode pressure",
	"k165": "Electrode Primary",
	"k166": "Electrode Secondary",
	"k167": "Electrode 1 counter",
	"k168": "Electrode 2 counter",
	"k169": "Electrode 1 grinding",
	"k170": "Electrode 2 grinding",
	"k171": "Workpiece Information",
	"k172": "Production Batch Number",
	"k173": "Operator",
	"k174": "Startup 1 Specification",
	"k175": "Startup 2 Specification",
	"k176": "Query",
	"k177": "Standardized Link Level",
	"k178": "Start extended to preload",
	"k179": "Function Selection",
	"k180": "Step up function",
	"k181": "Power Compensation(%)",
	"k182": "Repair welding function",
	"k183": "Detection Function",
	"k184": "Maximum number of welding repairs",
	"k185": "Start 2 function",
	"k186": "Single piece solder joint counter alarm",
	"k187": "Shift production count alarm",
	"k188": "Timing immediately after alarm reset",
	"k189": "Welding Clamp Process Welding Point Control",
	"k190": "Lower limit of welding point in welding clamp process",
	"k191": "Welding Clamp Process Welding Point Upper Limit",
	"k192": "End determination time of welding clamp welding point (seconds)",
	"k193": "Number of solder joints per piece",
	"k194": "Class output",
	"k195": "Total production quantity",
	"k196": "Total number of welding points",
	"k197": "Current value",
	"k198": "Reset",
	"k199": "Step increase level",
	"k200": "number of grinding times",
	"k201": "Grinding forecast warning",
	"k202": "Grinding upward pressure",
	"k203": "Downward pressure for grinding",
	"k204": "Step up 1",
	"k205": "Step up 2",
	"k206": "Step up 3",
	"k207": "Step up 4",
	"k208": "Step up 5",
	"k209": "Step up 6",
	"k210": "Step up 7",
	"k211": "Step up 8",
	"k212": "Step up 9",
	"k213": "Workpiece Name",
	"k214": "Error loading UIP curve data",
	"k215": "Offline retrieval setting error",
	"k216": "Device retrieval settings error",
	"k217": "Set output value for welding tongs team",
	"k218": "set value",
	"k219": "Pressure compensation(%)",
	"k220": "Please select a date range",
	"k221": "Date",
	"k222": "time",
	"k223": "Alarm content",
	"k224": "Record",
	"k225": "Creation time",
	"k226": "VIN code of the chassis",
	"k227": "Welding 1 (KA/ms)",
	"k228": "Welding 2 (KA/ms)",
	"k229": "Welding 3 (KA/ms)",
	"k230": "Currently using welding tongs number",
	"k231": "Energy (KJ)",
	"k232": "Output pulse width (%)",
	"k233": "Secondary voltage (v)",
	"k234": "Secondary resistance (μ Ohm)",
	"k235": "UIP value",
	"k236": "All",
	"k237": "No alarm",
	"k238": "There is an alarm",
	"k239": "Before modification",
	"k240": "Modified",
	"k241": "Solder joint number",
	"k242": "Line number",
	"k243": "Pressure (N)",
	"k244": "Plate thickness (mm)",
	"k245": "Model",
	"k246": "Solder joint information",
	"k247": "Material of Plate 1",
	"k248": "Thickness of Plate 1 (mm)",
	"k249": "Material of Plate 2",
	"k250": "Thickness of Plate 2 (mm)",
	"k251": "Material of Plate 3",
	"k252": "Thickness of Plate 3 (mm)",
	"k253": "Material of Plate 4",
	"k254": "Thickness of Plate 4 (mm)",
	"k255": "occurrence",
	"k256": "Reset",
	"k257": "Content",
	"k258": "Model number",
	"k259": "Solder joint mapping number",
	"k260": "Query parameter exception",
	"k261": "Current device",
	"k262": "Electrode 1",
	"k263": "Electrode 2",
	"k264": "Library ->Device",
	"k265": "Offline library not set, synchronization not allowed",
	"k266": "Abnormal export function",
	"k267": "Abnormal reading specification data",
	"k268": "Primary Key",
	"k269": "Part Name",
	"k270": "Preloading time ms",
	"k271": "Chasing time ms",
	"k272": "Pre welding current KA",
	"k273": "Pre welding time ms",
	"k274": "Cooling time 0 ms",
	"k275": "Slow rise time ms",
	"k276": "Welding 1 current KA",
	"k277": "Welding 1 time ms",
	"k278": "Cooling time 1 ms",
	"k279": "Welding 2 current KA",
	"k280": "Welding 2 time ms",
	"k281": "Cooling time 2 ms",
	"k282": "Welding 3 current KA",
	"k283": "Welding time 3 ms",
	"k284": "Slow descent time ms",
	"k285": "Cooling time 3 ms",
	"k286": "Rear welding current KA",
	"k287": "Post welding time ms",
	"k288": "Hold time ms",
	"k289": "Rest time ms",
	"k290": "step increase coefficient",
	"k291": "number of repetitions",
	"k292": "Current solder joint count",
	"k293": "Primary capacitor voltage",
	"k294": "Input port status (In00~In31)",
	"k295": "Output port status 0 (Out00~Out31)",
	"k296": "Current working mode of the system",
	"k297": "Number of single weld points for welding tongs 1",
	"k298": "Number of single welding points for welding tongs 2",
	"k299": "Production count value of welding tongs for Class 1",
	"k300": "Production count value of welding tongs for shift 2",
	"k301": "Total production count value of welding tongs 1",
	"k302": "Total production count value of welding tongs 2",
	"k303": "Total number of welding points for welding tongs 1",
	"k304": "Total number of welding points for welding tongs 2",
	"k305": "Number of steps for increasing the number of welding tongs in one step",
	"k306": "two-step incremental count value of welding tongs",
	"k307": "Number of grinding cycles for welding tongs 1",
	"k308": "Number of grinding cycles for welding tongs 2",
	"k309": "Welding tongs 2 current usage specification number",
	"k310": "Number of historical alarm records",
	"k311": "Currently using welding tongs number",
	"k312": "energy",
	"k313": "Load Capacity",
	"k314": "Secondary voltage",
	"k315": "Secondary resistance",
	"k316": "Alarm Flag",
	"k317": "Start 1 standard connection level",
	"k318": "Selection of pre pressure function with startup delay",
	"k319": "Step up function selection",
	"k320": "Upward pressure of A welding clamp mold repair",
	"k321": "Selection of welding repair function",
	"k322": "IO Function Selection",
	"k323": "A Welding Clamp Grinding Pressure",
	"k324": "End judgment time of welding clamp welding point",
	"k325": "Number of inverters",
	"k326": "Current feedback detection",
	"k327": "Control Function Priority Setting",
	"k328": "Step up series setting value",
	"k329": "step increment count value",
	"k330": "Setting value for grinding frequency",
	"k331": "Number of grinding counts",
	"k332": "Pre warning weld point setting value for grinding",
	"k333": "Step increase welding point 1",
	"k334": "Power Compensation 1",
	"k335": "Pressure Compensation 1",
	"k336": "Step increase welding point count 2",
	"k337": "Power Compensation 2",
	"k338": "Pressure Compensation 2",
	"k339": "Step up welding points by 3",
	"k340": "Power Compensation 3",
	"k341": "Pressure compensation 3",
	"k342": "Step increase welding point count 4",
	"k343": "Power Compensation 4",
	"k344": "Pressure compensation 4",
	"k345": "Step increase welding point count 5",
	"k346": "Power Compensation 5",
	"k347": "Pressure compensation 5",
	"k348": "Step increase welding point count 6",
	"k349": "Power Compensation 6",
	"k350": "Pressure compensation 6",
	"k351": "Step increase welding point count 7",
	"k352": "Power Compensation 7",
	"k353": "Pressure compensation 7",
	"k354": "Step increase welding point count 8",
	"k355": "Power Compensation 8",
	"k356": "Pressure compensation 8",
	"k357": "Step up welding points by 9",
	"k358": "Grinding upward pressure",
	"k359": "Grinding downward pressure",
	"k360": "Welding tongs configuration",
	"k361": "Welding Clamp Configuration Mode",
	"k362": "Single welding tongs",
	"k363": "Double welding tongs",
	"k364": "Multiple welding tongs",
	"k365": "Welding tongs wide open mode",
	"k366": "hold type",
	"k367": "Jogging type",
	"k368": "Electrode arm status during power outage",
	"k369": "Small opening",
	"k370": "Big Open",
	"k371": "Welding tongs with large open air valve type",
	"k372": "Single electronic control",
	"k373": "Dual electronic control",
	"k374": "Small opening delay start",
	"k375": "Welding is allowed when there is insufficient cooling water",
	"k376": "Welding tongs 2 water flow monitoring function",
	"k377": "User '{{.a}}' updates collection curve settings, device ID: '{{.b}}'",
	"k378": "User '{{.a}}' downloads DIP specification library for device '{{.b}}': '{{.c}}'",
	"k379": "X",
	"k380": "Y",
	"k381": "Z",
	"k382": "The solder joint mapping number already exists",
	"k383": "Successfully added solder joint",
	"k384": "Failed to add solder joint",
	"k385": "Successfully edited solder joint",
	"k386": "Edit solder joint failed",
	"k387": "Failed to save solder joint extension information",
	"k388": "Failed to query solder joint extension information",
	"k389": "Download failed, device {{.a}} may be offline",
	"k390": "The number of solder joints is invalid or greater than 2000 points",
	"k391": "UIR hasn't started yet",
	"k392": "The UIR record has started, there is no need to start again",
	"k393": "Start recording UIR",
	"k394": "Stop recording UIR",
	"k395": "Query data exception",
	"k396": "Select Curve",
	"k397": "Generate reference curve",
	"k398": "->Controller",
	"k399": "->PC",
	"k400": "One Package Curve",
	"k401": "Loading successful",
	"k402": "No alarm, no need to reset",
	"k403": "System parameter read error",
	"k404": "Imported file's current threshold mode does not match the imported device",
	"w001": "Welding 1 current exceeds the limit",
	"w002": "Welding 1 current too low",
	"w003": "Welding 2 current exceeds the limit",
	"w004": "Welding 2 current too low",
	"w005": "Welding 3 current exceeds the limit",
	"w006": "Welding 3 current too low",
	"w007": "IGBT fault",
	"w008": "Emergency stop fault",
	"w009": "Transformer 1 temperature exceeds the limit",
	"w010": "Medium frequency power supply temperature exceeds the limit",
	"w011": "Water flow switch error",
	"w012": "Air pressure switch error",
	"w013": "Welding allowed timeout",
	"w014": "Programmable Input 1 timeout",
	"w015": "Programmable Input 2 timeout",
	"w016": "Programmable Input 3 timeout",
	"w017": "Memory parameter table error",
	"w018": "Primary capacitor charging timeout",
	"w019": "Foot switch closing error when system is powered on",
	"w020": "Primary capacitor voltage too low",
	"w021": "Ferroelectric data write error",
	"w022": "Pre pressing time setting error",
	"w023": "RS485 communication failure",
	"w024": "Hanging welding: Welding tongs 2 water flow switch alarm",
	"w025": "Grating protection",
	"w026": "Transformer type setting error",
	"w027": "Constant current mode setting error",
	"w028": "Secondary current gear setting error",
	"w029": "Prohibit welding interface alarm",
	"w030": "Current output protection",
	"w031": "Transformer 2 temperature exceeds the limit",
	"w032": "Current feedback error",
	"w033": "The current number of welding points in welding tongs 1 has reached the set value for the number of welding points per piece",
	"w034": "The actual number of welding points in welding tongs 1 is greater than the upper limit of a single welding point",
	"w035": "The actual number of welding points in welding tongs 1 is less than the lower limit of a single welding point",
	"w036": "The production of welding tongs in Class 1 has reached the set value",
	"w037": "Welding tongs 1 grinding warning",
	"w038": "Welding tongs 1 grinding alarm",
	"w039": "Welding tongs 1 replacement alarm",
	"w040": "Welding tongs 1 replacement warning",
	"w041": "Retain 01",
	"w042": "The current number of welding points for welding tongs 2 has reached the set value for the number of welding points per piece",
	"w043": "The actual number of welding points in welding tongs 2 is greater than the upper limit of a single welding point",
	"w044": "The actual number of welding points in welding tongs 2 is less than the lower limit of a single welding point",
	"w045": "The production of welding tongs in Class 2 has reached the set value",
	"w046": "Welding tongs 2 grinding warning",
	"w047": "Welding tongs 2 grinding alarm",
	"w048": "Welding tongs 2 replacement alarm",
	"w049": "Welding tongs 2 replacement warning",
	"w050": "Reserve 49",
	"w051": "Reserve 50",
	"w052": "Retain 51",
	"w053": "Retain 52",
	"w054": "Retain 53",
	"w055": "Retain 54",
	"w056": "Retain 55",
	"w057": "Retain 56",
	"w058": "Retain 57",
	"w059": "Retain 58",
	"w060": "Retain 59",
	"w061": "RTC Error",
	"w062": "SD card write error",
	"w063": "Calibration parameter error",
	"w164": "Incremental parameter error",
	"w064": "Poor contact of current feedback line",
	"w065": "Welding resistance high alarm",
	"w066": "Welding resistance low alarm",
	"w067": "Abnormal secondary voltage cable",
	"w168": "UIP is too small",
	"w069": "UIP is too large",
	"w068": "Adaptive Welding Exception",
	"w097": "Welding splash alarm",
	"w098": "Pulse width output is too large",
	"w099": "UIP is too small",
	"w100": "UIP is too large",
	"z001": "{{.a}} (value range '{{.b}}~{{.c}} {{.d}}') Target setting value: '{{.e}}'",
	"z002": "Not a floating-point number: {{.a}}",
	"z003": "Not a string: {{.a}}",
	"z004": "Length is not {{.a}}, length is {{.b}}",
	"z005": "{{.a}} This method is not implemented by the controller",
	"z006": "Offline",
	"z007": "Online",
	"z008": "Exception",
	"z009": "Deleted",
	"z010": "{{.a}} input error",
	"z011": "Input verification error",
	"z012": "Alarm Record",
	"z013": "Debugging Program",
	"z014": "Database Management",
	"z015": "Modify Record",
	"z016": "Production Management",
	"z017": "Standard Parameters",
	"z018": "Welding Record",
	"z019": "Real time monitoring",
	"z020": "System Parameters",
	"z021": "Not activated",
	"z022": "Normal",
	"z023": "frozen",
	"z024": "Deleted",
	"z025": "Administrator",
	"z026": "Operator",
	"z027": "Inspector",
	"z028": "Specification number out of range (0-959)",
	"z029": "Specification number out of range (0-63)",
	"z030": "Controller 1 is not a valid integer",
	"z031": "Controller 2 is not a valid integer",
	"z032": "Specification number 1 is not a valid integer",
	"z033": "Specification number 2 is not a valid integer",
	"z034": "Same standard, no comparison allowed",
	"z035": "Workpiece Name",
	"z036": "Production Batch Number",
	"z037": "Operator",
	"z038": "Query offline specification error",
	"z039": "Not an integer: {{.a}}",
	"z040": "Reconnecting...",
	"g001": "Total welding point count of electrode holder 3",
	"g002": "Total weld count of electrode holder 4",
	"g003": "Total welding point count of electrode holder 5",
	"g004": "Setting value for 3-step level increment of welding tongs",
	"g005": "Setting value for grinding frequency of welding tongs 3",
	"g006": "Welding torch 3 grinding pre-alarm welding point set value",
	"g007": "Count value of 3-step increment for welding tongs",
	"g008": "Count of grinding times for electrode holder 3",
	"g009": "Setting value for 4-step level increment of welding tongs",
	"g010": "Setting value for grinding frequency of welding tongs 4",
	"g011": "Welding torch 4 grinding pre-alarm welding point set value",
	"g012": "Count value of 4-step level increment for welding tongs",
	"g013": "Count of grinding times for welding tongs 4",
	"g014": "Set value for 5-step increment of electrode holder",
	"g015": "Setting value for grinding frequency of electrode holder 5",
	"g016": "Welding torch 5 grinding pre-alarm welding point set value",
	"g017": "Count value of 5-step increment for welding tongs",
	"g018": "Count of grinding times for electrode holder 5",
	"g019": "Welding torch 3-step incremental welding point count 1",
	"g020": "Welding torch 3 power compensation 1",
	"g021": "Welding torch 3 pressure compensation 1",
	"g022": "Welding torch 3-step incremental welding point count 2",
	"g023": "Welding torch 3 power compensation 2",
	"g024": "Welding torch 3 pressure compensation 2",
	"g025": "welding tongs 3-step increase in welding point count 3",
	"g026": "Welding torch 3 power compensation 3",
	"g027": "Welding torch 3 pressure compensation 3",
	"g028": "welding tongs 3-step incremental welding point count 4",
	"g029": "Welding torch 3 power compensation 4",
	"g030": "Welding torch 3 pressure compensation 4",
	"g031": "welding tongs 3-step incremental welding point count 5",
	"g032": "Welding torch 3 power compensation 5",
	"g033": "welding torch 3 pressure compensation 5",
	"g034": "Welding torch 3-step incremental welding point count 6",
	"g035": "Welding torch 3 power compensation 6",
	"g036": "Welding torch 3 pressure compensation 6",
	"g037": "Welding torch 3-step incremental welding point count 7",
	"g038": "Electrode holder 3 power compensation 7",
	"g039": "Welding torch 3 pressure compensation 7",
	"g040": "Welding torch 3-step incremental welding point count 8",
	"g041": "Welding torch 3 power compensation 8",
	"g042": "Electrode holder 3 pressure compensation 8",
	"g043": "welding tongs 3-step incremental welding point count 9",
	"g044": "Electrode holder 3 power compensation 9",
	"g045": "Welding torch 3 pressure compensation 9",
	"g046": "Welding torch 4-step incremental welding point count 1",
	"g047": "Welding torch 4 power compensation 1",
	"g048": "Welding torch 4 pressure compensation 1",
	"g049": "Welding tongs 4-step increase in welding point count 2",
	"g050": "Electrode holder 4 power compensation 2",
	"g051": "Welding torch 4 pressure compensation 2",
	"g052": "Welding torch 4-step incremental welding point count 3",
	"g053": "Welding torch 4 power compensation 3",
	"g054": "welding torch 4 pressure compensation 3",
	"g055": "welding tongs 4-step incremental welding point count 4",
	"g056": "Welding torch 4 power compensation 4",
	"g057": "Electrode holder 4 pressure compensation 4",
	"g058": "welding tongs 4-step incremental welding point count 5",
	"g059": "Electrode holder 4 power compensation 5",
	"g060": "Welding torch 4 pressure compensation 5",
	"g061": "welding tongs 4-step incremental welding point count 6",
	"g062": "Electrode holder 4 power compensation 6",
	"g063": "welding torch 4 pressure compensation 6",
	"g064": "welding tongs 4-step incremental welding point count 7",
	"g065": "Electrode holder 4 power compensation 7",
	"g066": "welding torch 4 pressure compensation 7",
	"g067": "Welding torch 4-step incremental welding point count 8",
	"g068": "Electrode holder 4 power compensation 8",
	"g069": "welding tongs 4 pressure compensation 8",
	"g070": "Welding torch 4-step incremental welding point count 9",
	"g071": "Welding torch 4 power compensation 9",
	"g072": "Electrode holder 4 pressure compensation 9",
	"g073": "Welding torch 5-step incremental welding point count 1",
	"g074": "Welding torch 5 power compensation 1",
	"g075": "Welding torch 5 pressure compensation 1",
	"g076": "welding tongs 5-step increase in welding point count 2",
	"g077": "Electrode holder 5 power compensation 2",
	"g078": "Welding torch 5 pressure compensation 2",
	"g079": "Welding torch 5-step incremental welding point count 3",
	"g080": "Welding torch 5 power compensation 3",
	"g081": "welding torch 5 pressure compensation 3",
	"g082": "Welding torch 5-step incremental welding point count 4",
	"g083": "Welding torch 5 power compensation 4",
	"g084": "Welding torch 5 pressure compensation 4",
	"g085": "Welding torch 5 steps increase welding point count 5",
	"g086": "Electrode holder 5 power compensation 5",
	"g087": "welding torch 5 pressure compensation 5",
	"g088": "welding tongs 5-step incremental welding point count 6",
	"g089": "welding torch 5 power compensation 6",
	"g090": "welding torch 5 pressure compensation 6",
	"g091": "welding tongs 5-step incremental welding point count 7",
	"g092": "Electrode holder 5 power compensation 7",
	"g093": "welding torch 5 pressure compensation 7",
	"g094": "welding tongs 5-step incremental welding point count 8",
	"g095": "Electrode holder 5 power compensation 8",
	"g096": "Electrode holder 5 pressure compensation 8",
	"g097": "Welding tongs increase welding point count by 9 in 5 steps",
	"g098": "Welding torch 5 power compensation 9",
	"g099": "Electrode holder 5 pressure compensation 9",
	"g100": "Secondary constant current trimming parameter of electrode holder 3",
	"g101": "Welding torch 4 primary constant current trimming parameter",
	"g102": "Welding torch 4 secondary constant current trimming parameter",
	"g103": "Welding torch 5 primary constant current trimming parameter",
	"g104": "Welding torch 5 secondary constant current trimming parameter",
	"g105": "Minimum primary current PWM output setting value for electrode holder 3",
	"g106": "Welding torch 3 primary current PWM output setting value",
	"g107": "Welding torch 3 secondary primary current PWM output setting value",
	"g108": "Welding torch 3 three-stage primary current PWM output setting value",
	"g109": "Welding torch 3 four-stage primary current PWM output setting value",
	"g110": "Welding torch 3 five-stage primary current PWM output setting value",
	"g111": "Welding torch 3 six-stage primary current PWM output setting value",
	"g112": "Maximum primary current PWM output setting value for electrode holder 3",
	"g113": "Minimum current sampling value of electrode holder 3 primary",
	"g114": "Current sampling value of the primary section of electrode holder 3",
	"g115": "Current sampling value of electrode holder 3, primary stage 2",
	"g116": "Current sampling value of electrode holder 3, primary stage, third segment",
	"g117": "Current sampling value of the fourth stage of the primary circuit of electrode holder 3",
	"g118": "Current sampling value of electrode holder 3 at the fifth primary stage",
	"g119": "Current sampling value of electrode holder 3 at primary level, six-stage",
	"g120": "Maximum current sampling value of electrode holder 3 at primary level",
	"g121": "Display value of minimum primary current for electrode holder 3",
	"g122": "Welding torch 3 primary stage 1 current display value",
	"g123": "Display value of secondary current for electrode holder 3 (primary stage)",
	"g124": "Welding torch 3 primary three-stage current display value",
	"g125": "Welding torch 3 primary four-stage current display value",
	"g126": "Display value of current in the fifth stage of the primary circuit of electrode holder 3",
	"g127": "Welding torch 3 primary six-stage current display value",
	"g128": "Display value of maximum primary current for electrode holder 3",
	"g129": "Minimum secondary current PWM output setting value for electrode holder 3",
	"g130": "Secondary current PWM output setting value for electrode holder 3, section 1",
	"g131": "Secondary current PWM output setting value for electrode holder 3, section 2",
	"g132": "Welding torch 3 three-stage secondary current PWM output setting value",
	"g133": "Secondary current PWM output setting value for welding tong 3, section 4",
	"g134": "Welding torch 3 five-stage secondary current PWM output setting value",
	"g135": "Welding torch 3 six-stage secondary current PWM output setting value",
	"g136": "Maximum secondary current PWM output setting value for electrode holder 3",
	"g137": "Minimum current sampling value of electrode holder 3 secondary",
	"g138": "Welding torch 3 secondary current sampling value",
	"g139": "Secondary current sampling value of electrode holder 3",
	"g140": "Welding torch 3 secondary three-stage current sampling value",
	"g141": "Welding torch 3 secondary four-stage current sampling value",
	"g142": "Welding torch 3 secondary five-stage current sampling value",
	"g143": "Welding torch 3 secondary six-stage current sampling value",
	"g144": "Maximum current sampling value of electrode holder 3 secondary",
	"g145": "Minimum current display value of electrode holder 3 secondary",
	"g146": "Electrode holder 3 secondary current display value",
	"g147": "Electrode holder 3 secondary current display value",
	"g148": "Welding torch 3 secondary three-stage current display value",
	"g149": "Welding torch 3 secondary four-stage current display value",
	"g150": "Display value of five-stage current for electrode holder 3 secondary side",
	"g151": "Electrode holder 3 secondary six-stage current display value",
	"g152": "Display value of maximum secondary current of electrode holder",
	"g153": "Minimum primary current PWM output setting value for electrode holder 4",
	"g154": "Primary current PWM output setting value for electrode holder 4, section 1",
	"g155": "Welding torch 4 secondary primary current PWM output setting value",
	"g156": "Welding torch 4 three-stage primary current PWM output setting value",
	"g157": "Setting value for four-segment primary current PWM output of electrode holder 4",
	"g158": "Welding torch 4 five-stage primary current PWM output setting value",
	"g159": "Welding torch 4 six-stage primary current PWM output setting value",
	"g160": "Welding torch 4 maximum primary current PWM output setting value",
	"g161": "Minimum current sampling value of electrode holder 4 at primary level",
	"g162": "Current sampling value of the first stage of electrode holder 4",
	"g163": "Current sampling value of the second stage of the primary circuit of welding tongs 4",
	"g164": "Welding torch 4 primary three-stage current sampling value",
	"g165": "Current sampling value of the fourth primary stage of electrode holder 4",
	"g166": "Current sampling value of electrode holder 4 at the fifth primary stage",
	"g167": "Current sampling value of electrode holder 4 at the first six stages",
	"g168": "Maximum current sampling value of electrode holder 4 at primary level",
	"g169": "Welding torch 4 primary minimum current display value",
	"g170": "Current display value of primary section 1 of electrode holder 4",
	"g171": "Display value of primary two-stage current for electrode holder 4",
	"g172": "Electrode holder 4 primary three-stage current display value",
	"g173": "Electrode holder 4 primary four-stage current display value",
	"g174": "Welding torch 4 primary five-stage current display value",
	"g175": "Welding torch 4 primary six-stage current display value",
	"g176": "Display value of maximum primary current for welding tongs 4",
	"g177": "Minimum secondary current PWM output setting value for electrode holder 4",
	"g178": "Secondary current PWM output setting value for electrode holder 4, section 1",
	"g179": "Secondary current PWM output setting value for welding torch 4, section 2",
	"g180": "Welding torch 4 three-stage secondary current PWM output setting value",
	"g181": "Setting value for PWM output of four-stage secondary current of welding tongs 4",
	"g182": "Welding torch 4 five-stage secondary current PWM output setting value",
	"g183": "Welding torch 4 six-stage secondary current PWM output setting value",
	"g184": "Welding torch 4 maximum secondary current PWM output setting value",
	"g185": "Minimum current sampling value of electrode holder 4 secondary",
	"g186": "Welding torch 4 secondary current sampling value",
	"g187": "Secondary current sampling value of electrode holder 4",
	"g188": "Welding torch 4 secondary three-stage current sampling value",
	"g189": "Welding torch 4 secondary four-stage current sampling value",
	"g190": "Welding torch 4 secondary five-stage current sampling value",
	"g191": "Welding tongs 4 secondary six-stage current sampling values",
	"g192": "Maximum current sampling value of electrode holder 4 secondary side",
	"g193": "Welding torch 4 secondary minimum current display value",
	"g194": "Electrode holder 4 secondary current display value",
	"g195": "Display value of secondary two-stage current of electrode holder 4",
	"g196": "Welding torch 4 secondary three-stage current display value",
	"g197": "Welding torch 4 secondary four-stage current display value",
	"g198": "Welding torch 4 secondary five-stage current display value",
	"g199": "Welding torch 4 secondary six-stage current display value",
	"g200": "Maximum current display value of electrode holder 4 secondary",
	"g201": "Minimum primary current PWM output setting value for welding tongs 5",
	"g202": "Primary current PWM output setting value for electrode holder 5, section 1",
	"g203": "Welding torch 5 secondary primary current PWM output setting value",
	"g204": "Welding torch 5 three-stage primary current PWM output setting value",
	"g205": "Setting value for four-stage primary current PWM output of welding tongs 5",
	"g206": "Welding torch 5 five-stage primary current PWM output setting value",
	"g207": "Welding torch 5 six-stage primary current PWM output setting value",
	"g208": "Maximum primary current PWM output setting value for electrode holder 5",
	"g209": "Minimum current sampling value of electrode holder 5 at primary level",
	"g210": "Current sampling value of the primary section of electrode holder 5",
	"g211": "Current sampling value of electrode holder 5 at primary secondary stage",
	"g212": "Welding torch 5 primary three-stage current sampling value",
	"g213": "Current sampling value of the fourth stage of the primary circuit of welding tongs 5",
	"g214": "Current sampling value of electrode holder 5 at the fifth primary stage",
	"g215": "Welding torch 5 primary six-stage current sampling value",
	"g216": "Maximum current sampling value of electrode holder 5 at primary level",
	"g217": "Display value of minimum primary current for electrode holder 5",
	"g218": "Current display value of primary section 1 of electrode holder 5",
	"g219": "Welding torch 5 primary two-stage current display value",
	"g220": "Welding torch 5 primary three-stage current display value",
	"g221": "Welding torch 5 primary four-stage current display value",
	"g222": "Welding torch 5, primary five-stage current display value",
	"g223": "Welding torch 5 primary six-stage current display value",
	"g224": "Welding torch 5 primary maximum current display value",
	"g225": "Minimum secondary current PWM output setting value for electrode holder 5",
	"g226": "Secondary current PWM output setting value for electrode holder 5, section 1",
	"g227": "Welding torch 5 secondary current PWM output setting value",
	"g228": "Welding torch 5 three-stage secondary current PWM output setting value",
	"g229": "Welding torch 5 four-stage secondary current PWM output setting value",
	"g230": "Welding torch 5 five-stage secondary current PWM output setting value",
	"g231": "Welding torch 5 six-stage secondary current PWM output setting value",
	"g232": "Welding torch 5 maximum secondary current PWM output setting value",
	"g233": "Minimum current sampling value of electrode holder 5 secondary",
	"g234": "Welding torch 5 secondary current sampling value",
	"g235": "Secondary current sampling value of electrode holder 5",
	"g236": "Welding torch 5 secondary three-stage current sampling value",
	"g237": "Electrode holder 5 secondary four-segment current sampling value",
	"g238": "Welding torch 5 secondary five-stage current sampling value",
	"g239": "Welding torch 5 secondary six-stage current sampling value",
	"g240": "Maximum current sampling value of the secondary side of the welding tongs",
	"g241": "Welding torch 5 secondary minimum current display value",
	"g242": "Electrode holder 5 secondary current display value",
	"g243": "Welding torch 5 secondary two-stage current display value",
	"g244": "Welding torch 5 secondary three-stage current display value",
	"g245": "Welding torch 5 secondary four-stage current display value",
	"g246": "Welding torch 5 secondary five-stage current display value",
	"g247": "Welding torch 5 secondary six-stage current display value",
	"g248": "Welding torch 5 secondary maximum current display value",
	"g249": "Welding torch 3 primary constant current trimming parameter",
	"g250": "Undefined type: {{.a}}",
	"g251": "Pressure output setting value for one segment of electrode 3 of the welding tongs",
	"g252": "Set value of pressure output for the second section of electrode 3 of the welding tongs",
	"g253": "Measured pressure display value of one segment of electrode 3 of the welding tongs",
	"g254": "Measured value of pressure display for the second section of electrode 3 of the welding torch",
	"g255": "Pressure output setting value for one segment of electrode 4 of the welding tongs",
	"g256": "Set value for two-stage pressure output of electrode 4 of welding tongs",
	"g257": "Actual measured value of pressure display for one section of electrode 4 of the welding tongs",
	"g258": "Measured value of pressure display for the second section of electrode 4 of the welding tongs",
	"g259": "Pressure output setting value for one segment of electrode 5 of the welding torch",
	"g260": "Set value of two-stage pressure output for electrode 5 of welding tongs",
	"g261": "Measured pressure display value of one segment of electrode 5 of the welding tongs",
	"g262": "Measured value of pressure display for the second section of electrode 5 of the welding tongs",
	"d001": "Refresh quantity",
	"d002": "The solder joint mapping number cannot be empty and must be an integer",
	"d003": "The specification number cannot be empty and must be an integer",
	"d004": "The pressure cannot be empty and can only be an integer",
	"d005": "The plate thickness cannot be empty and can only be a decimal (value range: 0~99999.99)",
	"d006": "X cannot be empty and can only be a decimal (value range: 0~999.99)",
	"d007": "Y cannot be empty and can only be a decimal (value range: 0~999.99)",
	"d008": "Z cannot be empty and can only be a decimal (value range: 0~999.99)",
	"d009": "The thickness of Sheet 1 can only be a decimal (value range: 0~99999.99)",
	"d010": "The thickness of Sheet 2 can only be a decimal (value range: 0~99999.99)",
	"d011": "The thickness of plate 3 can only be a decimal (value range 0~99999.99)",
	"d012": "The thickness of plate 4 can only be a decimal (value range: 0~99999.99)",
	"d013": "Data cannot be restored after being cleared. Are you sure you want to clear it?",
	"d014": "System parameter record",
	"d015": "Solder Joint Management Record",
	"d016": "Operation type",
	"d017": "New",
	"d018": "Modify",
	"d019": "Parameter Comparison",
	"d020": "The operator does not exist, unable to query",
	"d021": "Missing or abnormal setting value",
	"d022": "Import quantity",
	"d023": "Calculating quantity",
	"d024": "verify quantity",
	"d025": "Clear Count",
	"d026": "Download Count",
	"d027": "Data cleanup successful",
	"d028": "Data cleanup failed",
	"d029": "Solder Joint Refresh",
	"d030": "Are you sure you want to refresh solder joints on the selected device?",
	"d031": "Solder joint refresh encountered an error and cannot proceed",
	"d032": "Solder joint refresh canceled",
	"d033": "Device is offline; this operation cannot be performed.",
	"d034": "Solder joint refresh successful",
	"d035": "Solder joint refresh progress overview",
	"d036": "Solder joint refresh details",
	"d037": "Solder joint refresh progress",
	"d038": "Solder joint refresh in progress",
	"d039": "Solder joint refresh failed",
	"d040": "Canceling solder joint refresh will halt subsequent operations. Are you sure you want to cancel?",
	"d041": "Solder joint task has been retried.",
	"e001": "Spatter Statistics",
	"e002": "Spatter Statistics View",
	"e003": "Spatter Statistics Management",
	"e004": "Query Dimension",
	"e005": "Solder Joint",
	"e006": "Query Dimension Error",
	"e007": "Spatter Count Value",
	"e008": "Solder Joint Count Value",
	"e009": "Total Count Value",
	"e010": "Spatter Pass Rate",
	"e011": "Data View",
	"e012": "Obtaining vehicle model data exception",
	"e013": "Solder joint filtering, multiple ones should be separated by ,",
	"e014": "Standardize filtering. For multiple entries, please separate them with a ,",
	"e015": "Click to copy",
	"e016": "Serial number",
	"e017": "<p>1. You can query the splash rate by selecting different dimensions. After selection, please click \"Query\".</p><p>2. After selecting the region/equipment/vehicle model/welding spot/specification, you can further select various regions/equipment/vehicle models from the list on the left for query.</p><p>3. After selecting the welding spot/specification, you can enter the welding spot/specification to be filtered in the search bar and then query (multiple entries separated by commas)</p>",
	"e018": "Factory",
	"e019": "Splash Record",
	"e020": "Effacer la requête",
	"e021": "Export complete",
	"e022": "Starting specification export",
	"e023": "Exporting specifications",
	"e024": "Starting synchronization",
	"e025": "Synchronizing",
	"e026": "Starting specification import",
	"e027": "Importing specifications",
	"e028": "Specification write error",
	"e029": "Start specification number",
	"e030": "End specification number",
	"e031": "Convert chassis VIN to serial number",
	"e032": "Please enter chassis VIN range",
	"e033": "Chassis VIN must be an integer",
	"e034": "UIP value must be an integer and greater than 0",
	"e035": "Supports reverse filtering of alarm content. For example, “!Welding1 Current Overlimit” will filter out records containing “Welding1 Current Overlimit”"
}